import { Trash2 } from "lucide-react";

const fmt = (iso) => { try { return new Date(iso).toLocaleString(); } catch { return iso; } };

export const SignupTable = ({ rows, total, q, setQ, role, setRole, onDelete }) => (
  <div className="rounded-2xl bg-white ring-1 ring-slate-200" data-testid="admin-signups-table">
    <div className="p-5 flex flex-col sm:flex-row gap-3 sm:items-center justify-between border-b border-slate-200">
      <p className="font-display text-lg font-bold text-[#13296B]">Sign-ups <span className="text-slate-500 font-mono text-sm">({rows.length} of {total})</span></p>
      <div className="flex gap-2">
        <select value={role} onChange={(e) => setRole(e.target.value)} data-testid="admin-role-filter" className="rounded-xl border-2 border-slate-200 px-3 py-2 text-sm">
          <option value="all">All roles</option>
          <option value="driver">Drivers</option>
          <option value="customer">Customers</option>
        </select>
        <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search name, email, ZIP" data-testid="admin-search-input" className="rounded-xl border-2 border-slate-200 px-3 py-2 text-sm w-full sm:w-64 outline-none focus:border-[#2F7FF0]" />
      </div>
    </div>
    <div className="overflow-x-auto">
      <table className="w-full text-sm min-w-[720px]">
        <thead className="text-left text-xs uppercase tracking-wider text-slate-500 bg-[#F7F9FC]">
          <tr>{["Signed up", "Role", "Name", "Email", "ZIP", "Vehicle", "Referrals", ""].map((h) => <th key={h} className="px-5 py-3 font-semibold">{h}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.id} className="border-t border-slate-100 hover:bg-[#F0F5FD]/60" data-testid={`admin-row-${r.id}`}>
              <td className="px-5 py-3 text-slate-600 whitespace-nowrap">{fmt(r.created_at)}</td>
              <td className="px-5 py-3"><span className={`rounded-full px-2.5 py-1 text-xs font-bold ${r.role === "driver" ? "bg-[#13296B] text-white" : "bg-[#F0F5FD] text-[#13296B]"}`}>{r.role}</span></td>
              <td className="px-5 py-3 font-semibold text-[#0B1938]">{r.name}</td>
              <td className="px-5 py-3 text-slate-700">{r.email}{r.email_status && <span className={`block text-[11px] ${r.email_status === "sent" ? "text-emerald-700" : "text-red-600"}`}>invite email {r.email_status}</span>}</td>
              <td className="px-5 py-3 font-mono">{r.zip}</td>
              <td className="px-5 py-3 text-slate-700">{r.vehicle_type || "—"}</td>
              <td className="px-5 py-3 font-mono text-[#13296B]" data-testid={`admin-referrals-${r.id}`}>{r.role === "driver" ? r.referrals ?? 0 : "—"}{r.referred_by && <span className="block text-[11px] text-slate-500">via {r.referred_by}</span>}</td>
              <td className="px-5 py-3 text-right"><button onClick={() => onDelete(r.id)} data-testid={`admin-delete-${r.id}`} className="text-slate-400 hover:text-red-600" aria-label="Delete"><Trash2 className="h-4 w-4" /></button></td>
            </tr>
          ))}
          {rows.length === 0 && <tr><td colSpan={8} className="px-5 py-12 text-center text-slate-500" data-testid="admin-empty-state">No sign-ups yet.</td></tr>}
        </tbody>
      </table>
    </div>
  </div>
);
